<mat-dialog-content>
    <mat-tab-group id="client-details-tabs-control" mat-stretch-tabs="false" mat-align-tabs="start"
        (selectedTabChange)="tabChanged($event)">
        <mat-tab label="Płatność">
            <div id="payment-tab-wrapper">
                <div id="payment-amount-header">
                    <span class="amount-label">Łącznie {{data.item?.status == 2 ? 'zapłacono' : 'do zapłaty'}}</span>
                    <span class="amount-value">{{data.item?.amount}}</span>
                </div>
                <div id="amount-details-table-wrapper" class="table-wrapper">
                    <mat-table id="amount-details-table" [dataSource]="amountDetails">
                        <ng-container matColumnDef="title">
                            <mat-header-cell *matHeaderCellDef>Nazwa</mat-header-cell>
                            <mat-cell *matCellDef="let item">{{item.title}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="netAmount">
                            <mat-header-cell *matHeaderCellDef class="cell-right">Netto</mat-header-cell>
                            <mat-cell *matCellDef="let item" class="cell-right">{{item.netAmount}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="grossAmount">
                            <mat-header-cell *matHeaderCellDef class="cell-right">Brutto</mat-header-cell>
                            <mat-cell *matCellDef="let item" class="cell-right">{{item.grossAmount}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="notes">
                            <mat-header-cell *matHeaderCellDef>Uwagi</mat-header-cell>
                            <mat-cell *matCellDef="let item">{{item.notes}}</mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="['title', 'netAmount', 'grossAmount', 'notes']"></mat-header-row>
                        <mat-row *matRowDef="let item; columns: ['title', 'netAmount', 'grossAmount', 'notes']"></mat-row>
                    </mat-table>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Raport">
            @if (billingReport$ | async; as br) {
                <div style="padding: 16px 24px;">
                <app-billing-report [billingReport]="br" [tableHeight]="260" [summaryMarginLeft]="12"></app-billing-report>
                </div>
            }
        </mat-tab>
        <mat-tab label="Log">
            <div id="card-charge-log-table-wrapper" class="table-wrapper">
                <mat-table id="card-charge-log-table" [dataSource]="cardChargeLog">
                    <ng-container matColumnDef="date">
                        <mat-header-cell *matHeaderCellDef>Data</mat-header-cell>
                        <mat-cell *matCellDef="let item">{{item.ts | date: 'dd.MM.yyyy
                            HH:mm'}}</mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="success">
                        <mat-header-cell *matHeaderCellDef class="cell-center">Sukces</mat-header-cell>
                        <mat-cell *matCellDef="let item" class="cell-center">
                            <span [outerHTML]="item.success | boolToImg"></span>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="details">
                        <mat-header-cell *matHeaderCellDef>Szczegóły</mat-header-cell>
                        <mat-cell *matCellDef="let item">{{item.details}}</mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="['date', 'success', 'details']"></mat-header-row>
                    <mat-row *matRowDef="let item; columns: ['date', 'success', 'details']"></mat-row>
                </mat-table>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>
